import { memberUrls } from "../../app/member-urls.js";

/**
 * 請求書の画面の URL。<b>今のアプリと同じ形</b>（<c>/TenantInvoice/Index?tenantId=</c>）。
 *
 * 1 通の画面は、今のアプリが作るリンク（<c>/TenantInvoice/Show/202601?tenantId=1</c>）も
 * 開ける（routes.tsx）。こちらから作るのはクエリの形。
 */
export const invoiceUrls = {
    tenants: memberUrls.tenants,
    /** 請求書のメニュー（自分が請求書を見られる契約。入口は契約一覧の「請求書」）。 */
    menu: "/TenantInvoice/Menu",
    list: (tenantId: number): string => `/TenantInvoice/Index?tenantId=${String(tenantId)}`,
    /** 請求書のメニューから開く一覧。戻るボタンが請求書のメニューを向き、1 通にも印を引き継ぐ（<c>from=menu</c>）。 */
    listFromMenu: (tenantId: number): string => `/TenantInvoice/Index?tenantId=${String(tenantId)}&from=menu`,
    /** 管理センターの契約の画面から開く一覧。戻るボタンが管理センターの契約の画面を向き、1 通にも印を引き継ぐ（<c>from=center</c>）。 */
    listFromCenter: (tenantId: number): string => `/TenantInvoice/Index?tenantId=${String(tenantId)}&from=center`,
    show: (tenantId: number, id: string): string =>
        `/TenantInvoice/Show?tenantId=${String(tenantId)}&id=${encodeURIComponent(id)}`,
    /** 管理センターの請求書の一覧から開く 1 通。戻るボタンが管理センターの契約の画面を向く（<c>from=center</c>）。 */
    showFromCenter: (tenantId: number, id: string): string =>
        `/TenantInvoice/Show?tenantId=${String(tenantId)}&id=${encodeURIComponent(id)}&from=center`,
    /** 請求書のメニューから開いた一覧から開く 1 通。戻るボタンが、メニューから開いた一覧を向く（<c>from=menu</c>）。 */
    showFromMenu: (tenantId: number, id: string): string =>
        `/TenantInvoice/Show?tenantId=${String(tenantId)}&id=${encodeURIComponent(id)}&from=menu`,
} as const;

/**
 * 一覧と 1 通をどこから開いたか（URL のクエリ <c>from</c>）。<b>知らない値は印なし</b>（契約一覧・契約情報から開いたとき）。
 * 戻るボタンの行き先だけを変える。開けるかどうかは API が決める。
 */
export type InvoiceEntry = "center" | "menu" | null;

export const invoiceEntryOf = (from: string | undefined): InvoiceEntry =>
    from === "center" || from === "menu" ? from : null;

/** 請求書の API（TenantInvoiceApiController）。値は URL から来るので必ず符号化する。 */
export const invoiceApi = {
    /** 請求書のメニュー（自分が請求書を見られる契約）。 */
    menu: "/api/invoices",
    list: (tenantId: string): string => `/api/tenants/${encodeURIComponent(tenantId)}/invoices`,
    show: (tenantId: string, id: string): string =>
        `/api/tenants/${encodeURIComponent(tenantId)}/invoices/${encodeURIComponent(id)}`,
} as const;
